import { makeVar, useReactiveVar } from '@apollo/client';

const STORAGE_KEY = 'mg_use_household_discount';

function readInitialValue(): boolean {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : false;
  } catch (e) {
    console.error(e);
    return false;
  }
}

export const mgUseHouseholdDiscountVar = makeVar<boolean>(readInitialValue());

function setUseHouseholdDiscount(value: boolean): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch (e) {
    console.error(e);
  }
  mgUseHouseholdDiscountVar(value);
}

export function useMgHouseholdDiscountToggle() {
  const useHouseholdDiscount = useReactiveVar(mgUseHouseholdDiscountVar);
  return { useHouseholdDiscount, setUseHouseholdDiscount };
}
